import { ElectoralDataANPRVM } from 'electoral/view-models/voter-detail';
import { SubjectData } from 'shell/models/person';

export const transformerElectoralDataANPR = (subject: SubjectData): ElectoralDataANPRVM => {
  const [electoralDataANPR] = subject.listaElettoraleCompleta?.liste || [];

  let municipalityVoter, codeMunicipalityVoter;

  if (subject.listaElettorale?.comune?.nomeComune) {
    municipalityVoter = subject.listaElettorale?.comune?.nomeComune;
    codeMunicipalityVoter = subject.listaElettorale?.comune?.codiceIstat;
  }

  const [list] = subject.listaElettoraleCompleta?.liste || [];

  if (list?.listaGenerale) {
    municipalityVoter = list?.listaGenerale?.comune?.nomeComune;
    codeMunicipalityVoter = list?.listaGenerale?.comune?.codiceIstat;
  }

  if (list?.listaAggiuntaComReg) {
    municipalityVoter = list?.listaAggiuntaComReg?.listaBolTreVal?.comune?.nomeComune;
    codeMunicipalityVoter = list?.listaAggiuntaComReg?.listaBolTreVal?.comune?.codiceIstat;
  }

  if (list?.listaAggiuntaUE?.listaAggiuntaUEComunali) {
    municipalityVoter = list?.listaAggiuntaUE?.listaAggiuntaUEComunali?.comune?.nomeComune;
    codeMunicipalityVoter = list?.listaAggiuntaUE?.listaAggiuntaUEComunali?.comune?.codiceIstat;
  }

  if (list?.listaAggiuntaUE?.listaAggiuntaUEParlamento) {
    municipalityVoter = list?.listaAggiuntaUE?.listaAggiuntaUEParlamento?.comune?.nomeComune;
    codeMunicipalityVoter = list?.listaAggiuntaUE?.listaAggiuntaUEParlamento?.comune?.codiceIstat;
  }

  return {
    codeMunicipalityVoter,
    certificability: subject.listaElettoraleCompleta?.certificabilita,
    parliamentUEList: electoralDataANPR?.listaAggiuntaUE?.ueelettoreparlamento === 'S',
    parliamentUEListSection:
      electoralDataANPR?.listaAggiuntaUE?.listaAggiuntaUEParlamento?.sezioneelettoralenum,
    municipalitiesUEList: electoralDataANPR?.listaAggiuntaUE?.ueelettorecomunali === 'S',
    municipalitiesUEListSection:
      electoralDataANPR?.listaAggiuntaUE?.listaAggiuntaUEComunali?.sezioneelettoralenum,
    bolzanoList: electoralDataANPR?.listaAggiuntaComReg?.comregelettorebolzano === 'S',
    trentoList: electoralDataANPR?.listaAggiuntaComReg?.comregelettoretrento === 'S',
    valleAostaList: electoralDataANPR?.listaAggiuntaComReg?.comregelettorevalledaosta === 'S',
    municipalRegionalListSection:
      electoralDataANPR?.listaAggiuntaComReg?.listaBolTreVal?.sezioneelettoralenum,
    generalList: !!electoralDataANPR?.listaGenerale,
    generalListSection: electoralDataANPR?.listaGenerale?.sezioneelettoralenum,
    flagVoter: electoralDataANPR?.elettore === 'S',
    houseOfRepresentatives: electoralDataANPR?.cameradeputati === 'S',
    electionMemberParliamentUE: electoralDataANPR?.elezionimembriue === 'S',
    circoscrizionali: electoralDataANPR?.circoscrizionali === 'S',
    republicSenate: electoralDataANPR?.senatorepubblica === 'S',
    circoscrizioneRepublicSenate:
      electoralDataANPR?.senatorepubblica === 'S' && electoralDataANPR?.circoscrsenatorepubblica
        ? electoralDataANPR?.circoscrsenatorepubblica
        : '',
    municipal: electoralDataANPR?.comunali === 'S',
    regional: electoralDataANPR?.regionali === 'S',
    nationalReferendum: electoralDataANPR?.referendumnazionali === 'S',
    circoscrizioneHouseOfRepresentatives:
      electoralDataANPR?.cameradeputati === 'S' && electoralDataANPR?.circoscrcameradeputati
        ? electoralDataANPR?.circoscrcameradeputati
        : '',
    municipalityVoter,
  };
};
